import { Box, Flex } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import styled from "styled-components";

export const PlanBenefitsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
  border-radius: 24px;
  border: 1px solid var(--Border-Disabled-grey50, #F5F5F5);
  background: #FFF;
  margin-top: -20px;
  padding: 24px 16px 24px 16px;
  width: auto;
  position: relative;
  z-index: 5;
`;

export const BenefitItem = styled(Box)`
`;

export const BenefitHeader = styled(Flex)`
  align-items: center;
  margin-bottom: 12px;
  gap: 12px;
`;

export const BenefitIcon = styled(Box)`
  font-size: 20px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #743DDC;
  border-radius: 8px;
  flex-shrink: 0;
`;

export const BenefitTitle = styled(Text)<{ isDashcamPlan?: boolean }>`
  color: var(--Purple-P500, #451999);
  font-family: "Euclid Circular B";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  ${props => !props.isDashcamPlan && `
    color: var(--Neutral-N600, #040222);
    font-family: "Euclid Circular B";
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
  `}
`;

export const BenefitList = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const BenefitListItem = styled(Flex)`
  color: var(--Neutral-N500, #36354C);
    font-family: "Euclid Circular B";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
`;

export const DottedSeparator = styled(Box)`
  height: 1px;
  background: repeating-linear-gradient(
    to right,
    #ddd 0px,
    #ddd 4px,
    transparent 4px,
    transparent 8px
  );
  width: 100%;
  margin: 8px 0;
`;

export const TickLogo = styled.div`
  display: flex;
  width: 16px;
  height: 16px;
  padding: 2px 2.347px 2.347px 2px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
`;

export const LearnMoreLink = styled.button`
  background: none;
  border: none;
  color: #1a1a1a;
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
  margin-top: 4px;
  transition: color 0.3s ease;
  align-self: flex-start;

  &:hover {
    color: #743DDC;
  }
`;
